module.exports = __webpack_public_path__ + "images/6c99f6a4a756c38f0e6f232cc84b0cfa.png";